<template>
    <CustomHeader :text="$t('bauDoTesouro.treasure')" />
    <div class="bauContainer">
        <van-row>
            <van-col :span="24">
                <img class="treasureTopImage" :src="dataSet.bannerIcon" alt="">
            </van-col>
        </van-row>

        <van-row class="secContainer">
            <van-col :span="24">
                <div class="menuLinkCont">
                    <div class="menuLinkWrapper">
                        <!-- <img style="width: 100%; position: relative;" src="@/assets/bauDo/menuLink_share_frame.png"
                            alt=""> -->
                        <p class="menueLinkTxt">{{ $t('common.myLink') }}</p>
                        <InputField class="inputFieldOverlay" :modelValue="dataSet.activityConfig?.link" />
                        <p class="menueLinkBtTxt">{{ $t('common.quickShare') }}</p>
                        <div style="position: absolute; display: flex;" class="mediaListMain">
                            <div v-for="(item, index) in mediaList" :key="index" class="mediaList" @click="goToShare"
                                style="display: flex; flex-direction: column; justify-content: center;align-items: center; padding: 8px;">
                                <img :src="item.icon" style="height: 24.75px; width: 24.75px;" class="" alt="">
                                <p style="color:#b4e6ec; font-size: 9px;">{{ $t(item.name) }}</p>
                            </div>
                        </div>

                    </div>
                    <div @click="goToUserDetails"
                        style="margin-top: 15px; background: linear-gradient(90deg, #c854ad 0%, #432e4f 100%); border-radius: 10px;">
                        <van-row style="padding: 0px 10px;">
                            <van-col span="15">
                                <p style="color: #ffffffd9; font-size: 13.98px;">{{ $t('bauDoTesouro.myReports') }}</p>
                            </van-col>
                            <van-col span="7"
                                style="color: #F0A853; font-size: 13.98px; display: flex; justify-content: flex-end; flex-direction: row;">
                                <p style="color: #F0A853; font-size: 15px; display: flex; justify-content: flex-end;">{{
                                    dataSet.activityConfig?.valid_user_count }}</p>
                                <p
                                    style="color: #F0A853; font-size: 11px; align-items: center; display: flex; margin-left: 5px; justify-content: flex-end;">
                                    {{ $t('common.pepole') }} </p>
                            </van-col>
                            <van-col span="2" style="display: flex; justify-content: flex-end; align-items: center;">
                                <img style="height: 24.75px; width: 24.75px;" src="@/assets/bauDo/arrow.png" alt="">
                            </van-col>
                        </van-row>
                    </div>
                    <div class="recordsCard" >
                        <van-row gutter="10" justify="center">
                            <van-col v-for="(item, index) in zigzagReordered" :key="index" span="6"
                                style="text-align: center;">
                                <RewardBox :peopleCount="item.valid_count" :reward="item.reward" :side="item.side"
                                    :down="item.turnDown" :isInCorner="item.isInCorner" :received="item?.received"
                                    :isLast="item.isLast" />
                            </van-col>
                        </van-row>
                    </div>
                </div>
            </van-col>
        </van-row>

        <div class="bottom_text">
            <div class="title">{{ $t("common.activityTitle") }}</div>
            <div class="line_text" v-for="(item, index) in dataSet.descriptionHtml" :key="index">
                {{ item }}
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, defineEmits, ref, defineProps } from 'vue';
import InputField from './components/inputField.vue';
import RewardBox from './components/rewardBox.vue';
import { toZigZagWithFlags } from '@/utils/commonFunction';
import CustomHeader from '../components/common/customHeader.vue';
import {MEDIA_LIST, TreasureData } from '@/view/bauDoTesouro/supportScript';

const mediaList = ref(MEDIA_LIST)

const props = defineProps<{
    dataSet: TreasureData
}>()

const emits = defineEmits(['goToShare', 'goToUserDetails'])
const zigzagReordered = computed(() => {
    const chunkSize = 4;
    const raw = [...(props.dataSet.activityConfig?.reward_conf || [])];
    const reordered: any[] = [];

    for (let i = 0; i < raw.length; i += chunkSize * 2) {
        const ltrRaw = raw.slice(i, i + chunkSize);            // left to right
        const rtlRaw = raw.slice(i + chunkSize, i + chunkSize * 2); // right to left (keep order)

        const ltr = ltrRaw.map((item, idx) => ({
            ...item,
            side: 'left',
            turnDown: idx === chunkSize - 1,                          // 4th in left
            isInCorner: idx === 0 || idx === chunkSize - 1           // 1st and 4th in left
        }));

        const rtl = rtlRaw.map((item, idx) => ({
            ...item,
            side: 'right',
            turnDown: idx === 0,                                     // 1st in right (5th overall)
            isInCorner: idx === 0 || idx === rtlRaw.length - 1       // 1st and last in right
        }));

        reordered.push(...ltr, ...rtl);
    }
    return toZigZagWithFlags(reordered, 4);

})


const goToShare = async () => {
   emits('goToShare')
}
const goToUserDetails = async () => {
   emits('goToUserDetails')
}

</script>
<style scoped>
.bauContainer {
    display: flex;
    justify-content: center;
    flex-direction: column;
    background-color: #221b24;
    padding: 0px 10px;
}


.treasureTopImage {
    width: 100%;
    padding-top: 44px;
}

.secContainer {
    display: flex;
    justify-content: center;
    padding: 0px 15px;
    flex-direction: column;
    margin-top: 0;
}

.menuLinkWrapper {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 25vh;
    background-color: #3f2e4b;
    border-radius: 10px;
}

.inputFieldOverlay {
    position: absolute;
    top: 15%;
    width: 87%;

}

.mediaListMain {
    position: absolute;
    top: 65%;
    z-index: 1;
}

.menuLinkCont {}

.rewardCard {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.menueLinkTxt {
    color: #ffffffd9;
    font-size: 14px;
    position: absolute;
    top: 0%;
    left: 7%;
    display: flex;
    justify-content: flex-start;
    z-index: 1;

}

.menueLinkBtTxt {
    color: #ffffffd9;
    font-size: 14px;
    position: absolute;
    top: 47%;
    display: flex;
    justify-content: flex-start;
    z-index: 1;

}

.active_channel {
    color: #fff;
    background-color: #00bbbb;
    border: 1px solid hsla(0, 0%, 100%, .45);
}

.bottom_text {
    padding: 25px;
}
.title {
    color: #7a4289;
    font-weight: bold;
    font-size: 15px;
    padding: 10px 0;
}

.line_text {
    color: #86718c;
    font-size: 13px;
    padding: 5px;
}

.recordsCard{
   padding-left: 10%; 
   background: #312734; 
   margin-top: 2%; 
   border-radius: 10px;
   max-height: 50vh; 
   overflow: hidden;
   overflow-y: scroll;
}
.recordsCard::-webkit-scrollbar {
    display: none;
}

</style>